module.exports = __webpack_public_path__ + "static/media/UMD-Psych-Seniors-300x250.17a660b4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ads/UMD-Psych-Seniors-300x250.gif
// module id = 38
// module chunks = 0